import type { StateTree } from '@makemydeal/dr-dash-types';

/**
 * Selector for incomplete trade modal visibility
 */
export const getShowIncompleteTradeModal = (state: StateTree): boolean => {
    return state.incompleteTradeModal?.showIncompleteTradeModal || false;
};

/**
 * Selector for bypass incomplete trade check flag.
 * True when user clicked "Continue" in the incomplete trade modal.
 * Also used by the middleware to defer save until PAYMENT_RECEIVED.
 */
export const getBypassIncompleteTradeCheck = (state: StateTree): boolean => {
    return state.incompleteTradeModal?.bypassIncompleteTradeCheck || false;
};
